export default __webpack_public_path__ + "static/media/chef6.121c1ba0.gif";